export var HOME_URL = '/org/[slug]/panel/inicio/';